import NotificationActions from '../../actions/NotificationActions';
import PopupActions from '../../actions/PopupActions';

import UserStore from '../../stores/UserStore';

import { endPoints as GuestEndPoints } from '../../constants/GuestConstants';
import AjaxPromises from '../../utils/AjaxPromises';

class TransactionNotes extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            notes   : this.props.notes
        };

        this.save = this.save.bind(this);
        this.loadNotes = this.loadNotes.bind(this);
    }

    componentDidMount() {
        this.loadNotes();
    }

    loadNotes() {
        var self = this;

        if (this.props.guest.ShipmentId.length === 0)
            return;

        AjaxPromises.POST(GuestEndPoints.GET_TRANSACTION_NOTE, UserStore.getApiData({
            TransactionId : this.props.guest.ShipmentId
        })).then(res => {
            if (res.Result) {
                self.setState({
                    notes : res.Data[0].TransactionNotes || ''
                })
            }
        });
    }

    save() {
        var self = this;

        AjaxPromises.POST(GuestEndPoints.SET_TRANSACTION_NOTE, UserStore.getApiData({
            TransactionNote : this.state.notes,
            GuestId : this.props.guest.Guest_id,
            TransId : this.props.guest.ShipmentId,
            TransactionId : this.props.guest.ShipmentId,
        })).then(res => {
            NotificationActions.addNotification({
                body : res.Result ? 'Notes updated' : 'Notes Failed to update',
                type : res.Result ? 'success' : 'alert'
            });

            if (res.Result) {
                self.setState({
                    visible : false
                });
            }
        });
    }

    render() {
        var self = this;

        return (
            <div className='popup popup__transparent'>

                <div className='popup__content sidebar-notes__edit'>

                    <div className='popup-header'>
                        Edit Notes

                        <div
                            className='popup-close'
                            onClick={() => { PopupActions.close(); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <textarea
                        value={this.state.notes}
                        className='sidebar-notes__edit--notes'
                        onChange={(e) => { this.setState({ notes : e.target.value }); }} />

                    <div
                        className='sidebar-notes__edit--save btn-green'
                        onClick={this.save}>

                        SAVE
                    </div>
                </div>
            </div>
        );
    }
}

export default TransactionNotes;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/TransactionNotes.react.jsx